import React from 'react';
import { COLORS, FONTS, primaryButtonStyle } from '../signup/signupStyles';

export const OpportunityLanding = ({ opportunity, onNext }) => (
  <div style={{
    minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
    fontFamily: FONTS.system
  }}>
    <style>{`
      @keyframes fadeUp {
        from { opacity: 0; transform: translateY(16px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .opp-cta:hover { background-color: #3a3a39 !important; transform: translateY(-1px) !important; }
      .opp-cta:active { transform: translateY(0) !important; }
    `}</style>

    <div style={{ maxWidth: '480px', width: '100%', animation: 'fadeUp 0.6s ease-out' }}>
      <div style={{
        background: '#ffffff', borderRadius: '12px',
        boxShadow: '0 4px 40px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.02)',
        overflow: 'hidden'
      }}>
        {/* Pay banner */}
        <div style={{
          background: COLORS.text, color: '#fff', padding: '20px 40px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '14px', fontWeight: '500', opacity: 0.7, marginBottom: '4px' }}>
            Earn up to
          </div>
          <div style={{
            fontFamily: FONTS.serif, fontSize: 'clamp(32px, 6vw, 42px)',
            fontWeight: '700', letterSpacing: '-0.02em'
          }}>
            {opportunity.pay}
          </div>
          <div style={{ fontSize: '14px', fontWeight: '500', opacity: 0.7, marginTop: '4px' }}>
            {opportunity.duration} · {opportunity.type}
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '32px 40px 40px' }}>
          <div style={{
            display: 'inline-block', fontSize: '12px', fontWeight: '600',
            textTransform: 'uppercase', letterSpacing: '0.8px',
            color: COLORS.salmon, marginBottom: '12px'
          }}>
            {opportunity.condition} Study
          </div>

          <h1 style={{
            fontFamily: FONTS.serif, fontSize: 'clamp(22px, 4vw, 28px)',
            fontWeight: '700', color: COLORS.text, lineHeight: 1.3,
            margin: '0 0 16px'
          }}>
            {opportunity.title}
          </h1>

          <p style={{
            fontSize: '15px', lineHeight: 1.6, color: '#6b6460',
            margin: '0 0 24px'
          }}>
            {opportunity.description}
          </p>

          <div style={{ marginBottom: '28px' }}>
            <div style={{
              fontSize: '13px', fontWeight: '600', color: COLORS.text,
              marginBottom: '10px'
            }}>
              Requirements
            </div>
            {opportunity.requirements.map((req, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                fontSize: '14px', color: '#6b6460', marginBottom: '6px'
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke={COLORS.salmon} strokeWidth="2.5" strokeLinecap="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                {req}
              </div>
            ))}
          </div>

          <button className="opp-cta" onClick={onNext} style={{
            ...primaryButtonStyle, display: 'block', width: '100%',
            padding: '16px 24px', fontSize: '16px'
          }}>
            Check If I Qualify
          </button>

          <p style={{
            fontSize: '12px', color: COLORS.muted, textAlign: 'center',
            margin: '16px 0 0', lineHeight: 1.5
          }}>
            Takes about 5 minutes. Your information stays private.
          </p>
        </div>
      </div>
    </div>
  </div>
);
